module.exports = "<div class=\"m-b-lg\"><img src=\"../../../assets/images/oops-page.png\" style=\"width:100%;\"/></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/subscription/subscription.pug
// module id = 281
// module chunks = 0